import events from './event.js';
import { getPopupProduct, getShopUrl } from './popupSpec.js';

/**
 * Fotobås, popup step 1 (Nytt steg 1, "Fotobås · steg 1"). PROTOTYPE: eight slots in two photo strips,
 * images picked in order, tap to select and swap, FORTSÄTT when all eight are filled. The images stay in
 * the browser (object URLs): no upload, no WooCommerce product, no print file yet.
 * Shown as an overlay over the popup (opened with ?popup=1&fotobas=1, see the shop card).
 */

const SLOTS = 8;
const CROPS = [['50% 50%', 1], ['56% 40%', 1.16], ['44% 46%', 1.08], ['50% 34%', 1.26], ['48% 56%', 1.05], ['62% 42%', 1.2], ['38% 50%', 1.12], ['52% 40%', 1.32]];
const ICON_PLUS = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M16 5h6M19 2v6"/><path d="M21 11.5V19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h7.5"/><path d="m21 15-3.1-3.1a2 2 0 0 0-2.8 0L6 21"/><circle cx="9" cy="9" r="2"/></svg>';
const ICON_CHECK = '<svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6 9 17l-5-5"/></svg>';

let current = null;
let wired = false;

export default class Booth {
    constructor(popupContentDiv) {
        this.popup = popupContentDiv;
        this.slots = new Array(SLOTS).fill(null); // object URL or null
        this.selected = -1;
        this.replaceIndex = -1; // slot a single-file pick should fill (Byt bild / empty slot)
        current = this;
        if (!wired) {
            wired = true;
            events.add('openFotobas', () => current?.open());
            events.add('closeFotobas', () => current?.close());
        }
    }

    build() {
        if (this.root) return;
        const product = getPopupProduct('fotobas', 'booth');
        const root = document.createElement('div');
        root.className = 'mscp-bth';
        root.hidden = true;

        const preview = document.createElement('div');
        preview.className = 'mscp-bth__preview';
        if (product) {
            const pv = document.createElement('div');
            pv.className = 'mscp-pv';
            pv.innerHTML = product.mockup;
            const win = pv.querySelector('.mscp-shop__win');
            if (win) {
                win.classList.add('mscp-bth__win');
                win.innerHTML = '<span class="mscp-bth__booth">' + [0, 1].map((s) => '<span class="mscp-bth__strip">' + [0, 1, 2, 3].map((k) => `<span class="mscp-bth__cell" data-i="${s * 4 + k}"></span>`).join('') + '</span>').join('') + '</span>';
                this.win = win;
            }
            preview.appendChild(pv);
        }
        const close = document.createElement('button');
        close.type = 'button';
        close.className = 'mscp-bth__close';
        close.setAttribute('aria-label', 'Stäng');
        close.innerHTML = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M18 6 6 18M6 6l12 12"/></svg>';
        close.addEventListener('click', () => events.trigger('hidePopup'));
        preview.appendChild(close);

        const body = document.createElement('div');
        body.className = 'mscp-bth__body';
        body.innerHTML = `
            <div class="mscp-up2__product">
                <div><div class="mscp-up2__name">FOTOTAVLA | FOTOBÅS</div><div class="mscp-up2__sizes">2 storlekar, 30×40 &amp; 40×50 cm</div></div>
                <a class="mscp-up2__swap" href="${getShopUrl()}">BYT</a>
            </div>
            <div class="mscp-bth__head"><h2 class="mscp-up2__title">Välj 8 bilder</h2><span class="mscp-bth__count"></span><button type="button" class="mscp-bth__clear">Rensa</button></div>
            <p class="mscp-bth__text">Bilderna hamnar i den ordning du väljer dem. Tryck på två bilder för att byta plats på dem.</p>
            <div class="mscp-bth__sel" hidden></div>
            <button type="button" class="mscp-up2__pick mscp-bth__pick">${ICON_PLUS}<span>VÄLJ BILDER</span></button>
            <button type="button" class="mscp-up2__pick mscp-bth__go" disabled><span>FORTSÄTT</span></button>
            <p class="mscp-bth__note" hidden>Prototyp: nästa steg är inte byggt än (ingen produkt eller tryckfil för Fotobås finns).</p>
            <ul class="mscp-up2__list"><li>${ICON_CHECK}Du kan välja alla bilder på en gång</li><li>${ICON_CHECK}Du beskär varje bild i nästa steg</li></ul>
            <p class="mscp-bth__price">30×40 cm 999 kr · 40×50 cm 1 099 kr</p>`;

        const input = document.createElement('input');
        input.type = 'file';
        input.accept = 'image/*';
        input.multiple = true;
        input.hidden = true;
        input.addEventListener('change', () => {
            this.addFiles([...input.files]);
            input.value = '';
        });
        this.input = input;

        root.append(preview, body, input);
        this.popup.appendChild(root);
        this.root = root;

        body.querySelector('.mscp-bth__pick').addEventListener('click', () => this.pick(-1));
        body.querySelector('.mscp-bth__clear').addEventListener('click', () => this.clearAll());
        body.querySelector('.mscp-bth__go').addEventListener('click', () => {
            if (this.slots.every(Boolean)) body.querySelector('.mscp-bth__note').hidden = false;
        });
        root.querySelectorAll('.mscp-bth__cell').forEach((cell) => {
            cell.addEventListener('click', () => this.tapCell(Number(cell.dataset.i)));
        });
        this.body = body;
    }

    open() {
        this.build();
        this.root.hidden = false;
        this.popup.classList.add('mscp-bth-on');
        this.render();
    }

    close() {
        if (!this.root) return;
        this.root.hidden = true;
        this.popup.classList.remove('mscp-bth-on');
    }

    pick(index) {
        this.replaceIndex = index;
        this.input.multiple = index < 0;
        this.input.click();
    }

    addFiles(files) {
        const images = files.filter((f) => f.type.startsWith('image/'));
        if (!images.length) return;
        if (this.replaceIndex >= 0) {
            this.setSlot(this.replaceIndex, URL.createObjectURL(images[0]));
        } else {
            // in the order chosen, into the empty slots; more than fit are dropped (the first eight count)
            for (const f of images) {
                const i = this.slots.findIndex((s) => !s);
                if (i < 0) break;
                this.slots[i] = URL.createObjectURL(f);
            }
        }
        this.replaceIndex = -1;
        this.render();
    }

    setSlot(i, url) {
        if (this.slots[i]) URL.revokeObjectURL(this.slots[i]);
        this.slots[i] = url;
    }

    tapCell(i) {
        if (this.selected < 0) {
            if (this.slots[i]) this.selected = i;
            else this.pick(i);
        } else if (this.selected === i) {
            this.selected = -1;
        } else {
            [this.slots[this.selected], this.slots[i]] = [this.slots[i], this.slots[this.selected]];
            this.selected = -1;
        }
        this.render();
    }

    clearAll() {
        this.slots.forEach((s) => s && URL.revokeObjectURL(s));
        this.slots.fill(null);
        this.selected = -1;
        this.render();
    }

    render() {
        if (!this.root) return;
        const filled = this.slots.filter(Boolean).length;
        this.root.querySelectorAll('.mscp-bth__cell').forEach((cell) => {
            const i = Number(cell.dataset.i);
            const url = this.slots[i];
            cell.classList.toggle('filled', !!url);
            cell.classList.toggle('sel', i === this.selected);
            cell.innerHTML = url ? `<img src="${url}" alt="" style="object-position:${CROPS[i][0]};transform:scale(${CROPS[i][1]})">` : `<span>${i + 1}</span>`;
        });
        this.body.querySelector('.mscp-bth__count').textContent = `${filled} av ${SLOTS}`;
        this.body.querySelector('.mscp-bth__clear').hidden = !filled;
        this.body.querySelector('.mscp-bth__go').disabled = filled < SLOTS;
        this.body.querySelector('.mscp-bth__pick').hidden = filled >= SLOTS;
        if (filled < SLOTS) this.body.querySelector('.mscp-bth__note').hidden = true;

        const sel = this.body.querySelector('.mscp-bth__sel');
        sel.hidden = this.selected < 0;
        if (this.selected >= 0) {
            sel.innerHTML = `<strong>Bild ${this.selected + 1} vald.</strong> Tryck på en annan ruta för att byta plats.<span class="mscp-bth__acts"><button type="button" data-a="swap">Byt bild</button><button type="button" data-a="del">Ta bort</button></span>`;
            sel.querySelector('[data-a=swap]').addEventListener('click', () => { const i = this.selected; this.selected = -1; this.pick(i); });
            sel.querySelector('[data-a=del]').addEventListener('click', () => { this.setSlot(this.selected, null); this.selected = -1; this.render(); });
        }
    }
}
